import { useContext, useState } from "react";
import { VerityApiContext } from "../../api/fetch";
import { CoreModal, coreToast } from "../../core";
import { useMobileLayout } from "../../hooks";
import { ProctoringOptionProfileV2 } from "@verity/proctoring-option/types";
import i18nPackage from "../../i18n/i18n";
import { Typography } from "@mui/material";

export const DeleteProfile = ({
	title,
	profile,
	refreshProfiles,
	open,
	onDelete,
	onClose,
}: {
	profile: ProctoringOptionProfileV2;
	title: string;
	refreshProfiles: () => Promise<void | Map<number, ProctoringOptionProfileV2>>;
	profiles: Array<ProctoringOptionProfileV2> | null;
	open: boolean;
	onDelete?: () => void;
	onClose: () => void;
}) => {
	const { deleteProctoringProfile } = useContext(VerityApiContext);
	const [deletedClicked, setDeleteClicked] = useState(false);
	const isMobileLayout = useMobileLayout();

	return (
		<CoreModal
			title={title}
			open={open}
			onClose={onClose}
			minWidth={isMobileLayout ? "min(100%, 550px)" : "min(60%, 550px)"}
			widthFixed
			buttons={[
				{
					text: i18nPackage.t("editQuizPage.deleteProfileModal.cancel"),
					color: "secondary",
					onClick: onClose,
				},
				{
					text: i18nPackage.t("editQuizPage.deleteProfileModal.delete"),
					color: "primary",
					onClick: () => {
						setDeleteClicked(true);
						deleteProctoringProfile(profile.id)
							.then(() => {
								onDelete?.();
								void refreshProfiles();
								coreToast.success(i18nPackage.t("editQuizPage.deleteProfileModal.success"));
							})
							.catch((e) => {
								console.error(e);
								coreToast.error(i18nPackage.t("editQuizPage.deleteProfileModal.error"));
							})
							.finally(onClose);
					},
					disabled: deletedClicked,
				},
			]}
		>
			<Typography>{i18nPackage.t("editQuizPage.deleteProfileModal.text")}</Typography>
		</CoreModal>
	);
};

export default DeleteProfile;